import { agent } from 'src/api/agent';
import { throwApiError } from 'src/api/utils';

import type { Directories } from '../directories/directories.store';

export class SystemSettingsApi {
  private readonly directories: Directories;

  constructor(directories: Directories) {
    this.directories = directories;
  }

  async loadSettings<T extends object = object>(settingsSection: string): Promise<T[]> {
    try {
      const { data } = await agent.get<T[]>(`/object/list/GOplan_SystemSettings_${settingsSection}`);

      return data;
    } catch (e) {
      throwApiError(e);
    }
  }

  async createSetting<T extends object = object>(settingsSection: string, setting: T): Promise<T> {
    try {
      const {
        data: { id: objectId },
      } = await agent.post<{ id: number }>(`/object/new/GOplan_SystemSettings_${settingsSection}`, setting);

      const { data } = await agent.get<T>(`/object/GOplan_SystemSettings_${settingsSection}/${objectId}`);

      return data;
    } catch (e) {
      throwApiError(e);
    }
  }

  async updateSettings<T extends object = object>(section: string, settingsId: number, updatedData: T): Promise<T[]> {
    try {
      const { data } = await agent.patch<T[]>(`/object/GOplan_SystemSettings_${section}/${settingsId}`, updatedData);

      return data;
    } catch (e) {
      throwApiError(e);
    }
  }
}
